// extracted by mini-css-extract-plugin
module.exports = {"lineup-player":"lineup-player","lineup-text":"lineup-text","shirt":"shirt","player-scores":"player-scores"};